import {handleAPI, API_VERSION_ONE} from '../../../itrust_common/utils/apiUtils';

export function tagsLoad(filters){
  const url = `/${API_VERSION_ONE}/tags`;
  const method = 'GET'
  return {
    type: 'TAGS_LOAD',
    payload: handleAPI(url, filters, method)
  };
}

export function tagLoad(id, filters){
  const url = `/${API_VERSION_ONE}/tags/${id}`;
  const method = 'GET'

  return {
    type: 'TAG_LOAD',
    payload: handleAPI(url,filters,method)
  };
}

export function tagCreate(data, filters){
  const url = `/${API_VERSION_ONE}/tags`;
  const method= 'POST'
  return {
    type: 'TAG_CREATE',
    payload: handleAPI(url,filters,method, {tag: {...data}})
  }
}

export function tagUpdate(data, filters){
  const url = `/${API_VERSION_ONE}/tags/${data.id}`;
  const method = "PUT"
  return {
    type: 'TAG_UPDATE',
    payload: handleAPI(url,filters,method, {tag: {...data}})
  }
}

export function tagDelete(id, filters) {
  const url = `/${API_VERSION_ONE}/tags/${id}`;
  const method = 'DELETE';

  return {
    type: 'TAG_DELETE',
    payload: new Promise((resolve, reject) => {
      handleAPI(url, filters, method)
        .then(response => {
          resolve({ id: id, ...response });
        })
        .catch(err => {
          reject(err);
        });
    })
  };
}

export function tagEdit(id) {
  return {
    type: 'TAG_EDIT',
    id,
  };
}

export function tagEditCancel() {
  return {
    type: 'TAG_EDIT_CANCEL'
  };
}
